export const MONTHLY_FTE_CHANGE_REPORT_STATISTICS = 'MONTHLY_FTE_CHANGE_REPORT_STATISTICS'
export const MONTHLY_FTE_CHANGE_REPORT_STATISTICS_SUCCESS = 'MONTHLY_FTE_CHANGE_REPORT_STATISTICS_SUCCESS'
export const MONTHLY_FTE_CHANGE_REPORT_STATISTICS_FAILED = 'MONTHLY_FTE_CHANGE_REPORT_STATISTICS_FAILED'

export const CLEAR_MONTHLY_FTE_CHANGE_REPORT_STATISTICS = 'CLEAR_MONTHLY_FTE_CHANGE_REPORT_STATISTICS'
